import { View, Text, styled } from 'tamagui'
import { useAppStore } from '@/store'

const Banner = styled(View, {
  width: '100%',
  height: 32,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  zIndex: 1500,
})

const BannerText = styled(Text, {
  fontFamily: '$fontMono',
  fontSize: 13,
  fontWeight: '600',
})

const RetryButton = styled(View, {
  paddingHorizontal: 10,
  paddingVertical: 2,
  borderRadius: '$borderRadiusSm',
  backgroundColor: 'rgba(255, 255, 255, 0.2)',
  cursor: 'pointer',
  hoverStyle: {
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
  },
})

const RetryText = styled(Text, {
  fontFamily: '$fontMono',
  fontSize: 12,
  fontWeight: '600',
  color: 'white',
})

function AnimatedDots() {
  return (
    <Text
      fontFamily="$fontMono"
      fontSize={13}
      fontWeight="600"
      color="white"
      // @ts-expect-error -- web animation
      style={{ animation: 'ellipsis 1.5s steps(4, end) infinite', width: 20, display: 'inline-block' }}
    >
      ...
    </Text>
  )
}

export function ConnectionBanner() {
  const { connectionStatus, setConnectionStatus } = useAppStore()

  if (connectionStatus === 'connected') return null

  if (connectionStatus === 'offline') {
    return (
      <Banner backgroundColor="#CF3E4F">
        <BannerText color="white">No internet connection</BannerText>
        <RetryButton onPress={() => setConnectionStatus('connecting')}>
          <RetryText>Retry</RetryText>
        </RetryButton>
      </Banner>
    )
  }

  const label = connectionStatus === 'reconnecting' ? 'Reconnecting' : 'Connecting'

  return (
    <Banner backgroundColor="#E8A840">
      <BannerText color="white">{label}</BannerText>
      <AnimatedDots />
    </Banner>
  )
}
